import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { heroBanners } from '../mock';

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroBanners.length), 6000);
    return () => clearInterval(t);
  }, []);

  const go = (n) => setIdx((idx + n + heroBanners.length) % heroBanners.length);

  return (
    <section className="relative w-full h-[88vh] min-h-[520px] overflow-hidden bg-neutral-100">
      {heroBanners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 hero-slide ${i === idx ? 'opacity-100' : 'opacity-0'}`}
          aria-hidden={i !== idx}
        >
          <img src={b.image} alt={b.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/15 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="px-8 md:px-20 max-w-3xl text-white">
              <div className="text-[11px] tracking-[0.4em] uppercase mb-4 opacity-90">New Collection</div>
              <h1 className="serif text-5xl md:text-7xl font-light leading-tight mb-4">{b.title}</h1>
              <p className="text-base md:text-xl font-light tracking-wide mb-8 opacity-95">{b.subtitle}</p>
              <a href={b.link} className="link-underline text-white">Discover More <span aria-hidden>&rarr;</span></a>
            </div>
          </div>
        </div>
      ))}

      {/* Controls */}
      <button onClick={() => go(-1)} aria-label="Previous" className="absolute left-4 md:left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white hover:bg-white hover:text-[#7a1a2a] transition-colors flex items-center justify-center">
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button onClick={() => go(1)} aria-label="Next" className="absolute right-4 md:right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white hover:bg-white hover:text-[#7a1a2a] transition-colors flex items-center justify-center">
        <ChevronRight className="w-5 h-5" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {heroBanners.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-[3px] transition-all ${i === idx ? 'w-10 bg-white' : 'w-5 bg-white/50'}`}
          />
        ))}
      </div>
    </section>
  );
}
